<template>
    <div>
        <div class="container mt-4">
            <div class="row">
                <div class="col-12 h-100">
                    <div v-if="hideFirstScreen">
                        <div class="c-hero-card-snackable">
                            <div class="c-hero-card-snackable__container">
                                <div class="c-hero-card-snackable__content">
                                    <div class="c-single-field-prompt">
                                        
                                        <p v-html="ageSectionText">
                                            
                                        </p>
                                        <div class="form-group row mt-5">
                                            <div class="col-12">
                                                <label for="EnterYourAge" class="col-form-label"
                                                    >{{ageLabel}}</label
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control form-control-lg mt-2"
                                                    :class="{
                                                        'is-invalid':
                                                            ageValidation,
                                                    }"
                                                    id="EnterYourAge"
                                                    placeholder="0 to 80"
                                                    aria-describedby="ageyears"
                                                    v-model="userAgeValue"
                                                    @input="handleUpperInput('year')"
                                                    @blur = "handleValidation"
                                                />
                                                <div
                                                class="invalid-feedback custom-invalid-feedback"
                                                aria-live="polite">
                                                    
                                                        {{ ageValidationError }}
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            @click="redirectNxtScreen"
                                            class="btn btn-round btn-lg btn-danger w-50 cal-btn"
                                            type="submit">
                                            Submit
                                        </button>
                                        <p
                                            class="c-daily-journey__slide-number mt-3">
                                            1 of 3
                                        </p>
                                    </div>
                                </div>
                                <div
                                    class="c-hero-card-snackable__media h-placeholder-image">
                                    <img
                                        src="assets/images/placeholder.gif"
                                        v-lazy-img="
                                            '//placeimg.com/1200/600/any'"alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="firstStep">
                        <RiskKidsPrimacy
                            :handleFirstScreen="handleFirstScreen"
                            :userAgeValue="userAgeValue"
                            :heightErrorMessage = "heightErrorMessage"
                            :weightErrorMessage = "weightErrorMessage"
                            :maxLvotGradientErrorMessage = "maxLvotGradientErrorMessage"
                            :sexLabel  = "sexLabel"
                            :heightLabel = "heightLabel"
                            :weightLabel = "weightLabel"
                            :laSizeLabel = "laSizeLabel"
                            :maxLvotGradientLabel = "maxLvotGradientLabel"
                            :mlvwtLabel = "mlvwtLabel"
                            :isdLabel = "isdLabel"
                            :gpLabel = "gpLabel"
                            :usLabel = "usLabel"
                            :nsvtLabel = "nsvtLabel"
                            :gsLabel = "gsLabel"
                            :efLabel = "efLabel"
                            :fhscdLabel  = "fhscdLabel"
                            :aaLabel = "aaLabel"
                            :lgeLabel = "lgeLabel"
                            :laSizeHelpText = "laSizeHelpText"
                            :maxLvotGradientHelpText = "maxLvotGradientHelpText"
                            :mlvwtHelpText = "mlvwtHelpText"
                            :isdHelpText = "isdHelpText"
                            :gpHelpText = "gpHelpText"
                            :usHelpText = "usHelpText"
                            :nsvtHelpText ="nsvtHelpText"
                            :gsHelpText="gsHelpText"
                            :efHelpText = "efHelpText"
                            :fhscdHelpText = "fhscdHelpText"
                            :aaHelpText = "aaHelpText"
                            :lgeHelpText = "lgeHelpText"
                            :isdErrorMessage="isdErrorMessage"
                            :mlvwtErrorMessage = "mlvwtErrorMessage"
                             :laSizeErrorMessage = "laSizeErrorMessage"
                             :hcmScdRecommendationLabel = "hcmScdRecommendationLabel"
                            :hcmScdRecommendationDescription = "hcmScdRecommendationDescription"
                            :hcmScdScoreLabel = "hcmScdScoreLabel"
                            :hcmScdScoreDescription = "hcmScdScoreDescription"
                            :hcmRiskKidsScoreLabel = "hcmRiskKidsScoreLabel"
                            :hcmRiskKidsScoreDescription = "hcmRiskKidsScoreDescription"
                            :primacyRiskScoreLabel = "primacyRiskScoreLabel"
                            :primacyRiskScoreDescription = "primacyRiskScoreDescription"
                            :lvmwtZScoreLabel = "lvmwtZScoreLabel"
                            :lvmwtZScoreDescription = "lvmwtZScoreDescription"
                            :laDiameterZScoreLabel = "laDiameterZScoreLabel"
                            :laDiameterZScoreDescription = "laDiameterZScoreDescription"
                           :prognosticIndexLabel = "prognosticIndexLabel"
                           :prognosticIndexDescription = "prognosticIndexDescription"
                           :errorModalHeaderText = "errorModalHeaderText"
                           :errorModalFooterText = "errorModalFooterText"
                           :calculatorVersionText = "calculatorVersionText"
                            :resultGuidelineText = "resultGuidelineText"
                            :riskHeaderText = "riskHeaderText"
                            :posteriorLvLabel = "posteriorLvLabel"
                            :posteriorLvErrorMessage = "posteriorLvErrorMessage"
                             :hcmRecommendationDescription = "hcmRecommendationDescription"
                             :patientSelectionLabel = "patientSelectionLabel"
                             :resultGuidelineTextSixteen = "resultGuidelineTextSixteen"
                             :resultGuidelineTextAdult = "resultGuidelineTextAdult"
                        />
                    </div>
                    <div v-if="secondStep">
                        <RiskHCMPrimacy 
                        :userAgeValue="userAgeValue"
                            :heightErrorMessage = "heightErrorMessage"
                            :weightErrorMessage = "weightErrorMessage"
                            :maxLvotGradientErrorMessage = "maxLvotGradientErrorMessage"
                            :sexLabel  = "sexLabel"
                            :heightLabel = "heightLabel"
                            :weightLabel = "weightLabel"
                            :laSizeLabel = "laSizeLabel"
                            :maxLvotGradientLabel = "maxLvotGradientLabel"
                            :mlvwtLabel = "mlvwtLabel"
                            :isdLabel = "isdLabel"
                            :gpLabel = "gpLabel"
                            :usLabel = "usLabel"
                            :nsvtLabel = "nsvtLabel"
                            :gsLabel = "gsLabel"
                            :efLabel = "efLabel"
                            :fhscdLabel  = "fhscdLabel"
                            :aaLabel = "aaLabel"
                            :lgeLabel = "lgeLabel"
                            :laSizeHelpText = "laSizeHelpText"
                            :maxLvotGradientHelpText = "maxLvotGradientHelpText"
                            :mlvwtHelpText = "mlvwtHelpText"
                            :isdHelpText = "isdHelpText"
                            :gpHelpText = "gpHelpText"
                            :usHelpText = "usHelpText"
                            :nsvtHelpText ="nsvtHelpText"
                            :gsHelpText="gsHelpText"
                            :efHelpText = "efHelpText"
                            :fhscdHelpText = "fhscdHelpText"
                            :aaHelpText = "aaHelpText"
                            :lgeHelpText = "lgeHelpText"
                            :handleSecondScree = "handleSecondScree"
                            :isdErrorMessage="isdErrorMessage"
                            :mlvwtErrorMessage = "mlvwtErrorMessage"
                             :laSizeErrorMessage = "laSizeErrorMessage"
                             :hcmScdRecommendationLabel = "hcmScdRecommendationLabel"
                            :hcmScdRecommendationDescription = "hcmScdRecommendationDescription"
                            :hcmScdScoreLabel = "hcmScdScoreLabel"
                            :hcmScdScoreDescription = "hcmScdScoreDescription"
                            :hcmRiskKidsScoreLabel = "hcmRiskKidsScoreLabel"
                            :hcmRiskKidsScoreDescription = "hcmRiskKidsScoreDescription"
                            :primacyRiskScoreLabel = "primacyRiskScoreLabel"
                            :primacyRiskScoreDescription = "primacyRiskScoreDescription"
                            :lvmwtZScoreLabel = "lvmwtZScoreLabel"
                            :lvmwtZScoreDescription = "lvmwtZScoreDescription"
                            :laDiameterZScoreLabel = "laDiameterZScoreLabel"
                            :laDiameterZScoreDescription = "laDiameterZScoreDescription"
                           :prognosticIndexLabel = "prognosticIndexLabel"
                           :prognosticIndexDescription = "prognosticIndexDescription"
                           :errorModalHeaderText = "errorModalHeaderText"
                           :errorModalFooterText = "errorModalFooterText"
                           :calculatorVersionText = "calculatorVersionText"
                            :resultGuidelineText = "resultGuidelineText"
                            :riskHeaderText = "riskHeaderText"
                             :hcmRecommendationDescription = "hcmRecommendationDescription"
                             :patientSelectionLabel = "patientSelectionLabel"
                             :resultGuidelineTextSixteen = "resultGuidelineTextSixteen"
                             :resultGuidelineTextAdult = "resultGuidelineTextAdult"
                        />
                    </div>
                    <div v-if="thirdStep">
                        <HcmScdCalculator 
                        :userAgeValue="userAgeValue"
                            :heightErrorMessage = "heightErrorMessage"
                            :weightErrorMessage = "weightErrorMessage"
                            :maxLvotGradientErrorMessage = "maxLvotGradientErrorMessage"
                            :sexLabel  = "sexLabel"
                            :heightLabel = "heightLabel"
                            :weightLabel = "weightLabel"
                            :laSizeLabel = "laSizeLabel"
                            :maxLvotGradientLabel = "maxLvotGradientLabel"
                            :mlvwtLabel = "mlvwtLabel"
                            :isdLabel = "isdLabel"
                            :gpLabel = "gpLabel"
                            :usLabel = "usLabel"
                            :nsvtLabel = "nsvtLabel"
                            :gsLabel = "gsLabel"
                            :efLabel = "efLabel"
                            :fhscdLabel  = "fhscdLabel"
                            :aaLabel = "aaLabel"
                            :lgeLabel = "lgeLabel"
                            :laSizeHelpText = "laSizeHelpText"
                            :maxLvotGradientHelpText = "maxLvotGradientHelpText"
                            :mlvwtHelpText = "mlvwtHelpText"
                            :isdHelpText = "isdHelpText"
                            :gpHelpText = "gpHelpText"
                            :usHelpText = "usHelpText"
                            :nsvtHelpText ="nsvtHelpText"
                            :gsHelpText="gsHelpText"
                            :efHelpText = "efHelpText"
                            :fhscdHelpText = "fhscdHelpText"
                            :aaHelpText = "aaHelpText"
                            :lgeHelpText = "lgeHelpText"
                            :handleThirdScreen = "handleThirdScreen"
                            :isdErrorMessage="isdErrorMessage"
                            :mlvwtErrorMessage = "mlvwtErrorMessage"
                            :laSizeErrorMessage = "laSizeErrorMessage"
                            :hcmScdRecommendationLabel = "hcmScdRecommendationLabel"
                            :hcmScdRecommendationDescription = "hcmScdRecommendationDescription"
                            :hcmScdScoreLabel = "hcmScdScoreLabel"
                            :hcmScdScoreDescription = "hcmScdScoreDescription"
                            :hcmRiskKidsScoreLabel = "hcmRiskKidsScoreLabel"
                            :hcmRiskKidsScoreDescription = "hcmRiskKidsScoreDescription"
                            :primacyRiskScoreLabel = "primacyRiskScoreLabel"
                            :primacyRiskScoreDescription = "primacyRiskScoreDescription"
                            :lvmwtZScoreLabel = "lvmwtZScoreLabel"
                            :lvmwtZScoreDescription = "lvmwtZScoreDescription"
                            :laDiameterZScoreLabel = "laDiameterZScoreLabel"
                            :laDiameterZScoreDescription = "laDiameterZScoreDescription"
                           :prognosticIndexLabel = "prognosticIndexLabel"
                           :prognosticIndexDescription = "prognosticIndexDescription"
                           :errorModalHeaderText = "errorModalHeaderText"
                           :errorModalFooterText = "errorModalFooterText"
                           :calculatorVersionText = "calculatorVersionText"
                            :resultGuidelineText = "resultGuidelineText"
                            :riskHeaderText = "riskHeaderText"
                             :hcmRecommendationDescription = "hcmRecommendationDescription"
                             :patientSelectionLabel = "patientSelectionLabel"
                             :resultGuidelineTextSixteen = "resultGuidelineTextSixteen"
                             :resultGuidelineTextAdult = "resultGuidelineTextAdult"

                        />
                    </div>
                    <div v-if="fourthStep">
                        <HcmScdCalculator
                             :userAgeValue="userAgeValue"
                            :heightErrorMessage = "heightErrorMessage"
                            :weightErrorMessage = "weightErrorMessage"
                            :maxLvotGradientErrorMessage = "maxLvotGradientErrorMessage"
                            :sexLabel  = "sexLabel"
                            :heightLabel = "heightLabel"
                            :weightLabel = "weightLabel"
                            :laSizeLabel = "laSizeLabel"
                            :maxLvotGradientLabel = "maxLvotGradientLabel"
                            :mlvwtLabel = "mlvwtLabel"
                            :isdLabel = "isdLabel"
                            :gpLabel = "gpLabel"
                            :usLabel = "usLabel"
                            :nsvtLabel = "nsvtLabel"
                            :gsLabel = "gsLabel"
                            :efLabel = "efLabel"
                            :fhscdLabel  = "fhscdLabel"
                            :aaLabel = "aaLabel"
                            :lgeLabel = "lgeLabel"
                            :laSizeHelpText = "laSizeHelpText"
                            :maxLvotGradientHelpText = "maxLvotGradientHelpText"
                            :mlvwtHelpText = "mlvwtHelpText"
                            :isdHelpText = "isdHelpText"
                            :gpHelpText = "gpHelpText"
                            :usHelpText = "usHelpText"
                            :nsvtHelpText ="nsvtHelpText"
                            :gsHelpText="gsHelpText"
                            :efHelpText = "efHelpText"
                            :fhscdHelpText = "fhscdHelpText"
                            :aaHelpText = "aaHelpText"
                            :lgeHelpText = "lgeHelpText"
                            :handleFourthScreen = "handleFourthScreen"
                            :isdErrorMessage="isdErrorMessage"
                            :mlvwtErrorMessage = "mlvwtErrorMessage"
                            :laSizeErrorMessage = "laSizeErrorMessage"
                            :hcmScdRecommendationLabel = "hcmScdRecommendationLabel"
                            :hcmScdRecommendationDescription = "hcmScdRecommendationDescription"
                            :hcmScdScoreLabel = "hcmScdScoreLabel"
                            :hcmScdScoreDescription = "hcmScdScoreDescription"
                            :calculatorVersionText = "calculatorVersionText"
                            :resultGuidelineText = "resultGuidelineText"
                            :riskHeaderText = "riskHeaderText"
                            :errorModalHeaderText = "errorModalHeaderText"
                             :errorModalFooterText = "errorModalFooterText"
                             :hcmRecommendationDescription = "hcmRecommendationDescription"
                             :patientSelectionLabel = "patientSelectionLabel"
                             :resultGuidelineTextSixteen = "resultGuidelineTextSixteen"
                             :resultGuidelineTextAdult = "resultGuidelineTextAdult"

                            />
                    </div>
                </div>
            </div>
        </div>
        <!-- Text goes here -->
         <!-- <div class="mt-3 mb-3"  v-html="riskHeaderText"></div>
         <div class="mt-3 mb-3 " v-html="riskFooterText"></div> -->
    </div>
</template>

<script>
// import Vue from 'vue';
/* eslint-disable */
import HcmScdCalculator from "./hcm-scd-calculator.vue";
import RiskKidsPrimacy from "./risk-kids-primacy.vue";
import RiskHCMPrimacy from "./risk-hcm-primacy.vue";
import HcmPrimacy from "./hcm-primacy.vue";

export default {
    components: {
        HcmScdCalculator,
        RiskKidsPrimacy,
        RiskHCMPrimacy,
        HcmPrimacy,
    },
    props: {
        //popup messages
        resultGuidelineTextSixteen: {
            type: String,
            required: true
        },
        resultGuidelineTextAdult :{
            type: String,
            required: true
        },
        hcmRecommendationDescription: {
            type: String,
            required: true
        },
        patientSelectionLabel: {
            type: String,
            required: true
        },
        posteriorLvErrorMessage:{
            type: String,
            required: true
        },
        posteriorLvLabel: {
            type: String,
            required: true
        },
        resultGuidelineText: {
            type: String,
            required: true
        },
        calculatorVersionText: {
            type: String,
            required: true
        },

        ageLabel: {
            type: String,
            required: true
        },

        riskHeaderText:{
            type: String,
            required: true
        },
        riskFooterText:{
            type: String,
            required: true
        },
        ageLabel:{
            type: String,
            required: true
        },
        ageHelpText:{
            type: String,
            required: true
        },
        ageSectionText : {
            type: String,
            required: true
        },

        //Error message
        ageHelpText: {
            type: String,
            required: true
        } ,
        ageIfEightyErrorMessage:{
            type: String,
            required: true
        },
        heightErrorMessage:{
            type: String,
            required: true
        },
        weightErrorMessage:{
            type: String,
            required: true
        },
        laSizeErrorMessage:{
            type: String,
            required: true
        },
        maxLvotGradientErrorMessage:{
            type: String,
            required: true
        },
        mlvwtErrorMessage:{
            type: String,
            required: true
        },
        isdErrorMessage:{
            type: String,
            required: true
        },
        //labels
        sexLabel:{
            type: String,
            required: true
        },
        heightLabel:{
            type: String,
            required: true
        },
        weightLabel:{
            type: String,
            required: true
        },
        laSizeLabel:{
            type: String,
            required: true
        },
        maxLvotGradientLabel:{
            type: String,
            required: true
        },
        
        mlvwtLabel:{
            type: String,
            required: true
        },
        isdLabel:{
            type: String,
            required: true
        },
        gpLabel:{
            type: String,
            required: true
        },
        usLabel:{
            type: String,
            required: true
        },
        nsvtLabel:{
            type: String,
            required: true
        },
        gsLabel:{
            type: String,
            required: true
        },
        efLabel:{
            type: String,
            required: true
        },
        fhscdLabel:{
            type: String,
            required: true
        },
        aaLabel:{
            type: String,
            required: true
        },
        lgeLabel:{
            type: String,
            required: true
        },
        //help text
        laSizeHelpText:{
            type: String,
            required: true
        },
        maxLvotGradientHelpText:{
            type: String,
            required: true
        },
        mlvwtHelpText:{
            type: String,
            required: true
        },
        isdHelpText:{
            type: String,
            required: true
        },
        gpHelpText:{
            type: String,
            required: true
        },
        usHelpText:{
            type: String,
            required: true
        },
        nsvtHelpText:{
            type: String,
            required: true
        },
        gsHelpText:{
            type: String,
            required: true
        },
        efHelpText:{
            type: String,
            required: true
        },
        fhscdHelpText:{
            type: String,
            required: true
        },
        aaHelpText:{
            type: String,
            required: true
        },
        lgeHelpText:{
            type: String,
            required: true
        },
        ageErrorMessage:{
            type: String,
            required: true
        },
        //modal Text 
        hcmRiskKidsScoreLabel:{
            type: String,
            required: true
        },

        hcmRiskKidsScoreDescription:{
            type: String,
            required: true
        },
        primacyRiskScoreLabel:{
            type: String,
            required: true
        },

        primacyRiskScoreDescription:{
            type: String,
            required: true
        },
        lvmwtZScoreLabel:{
            type: String,
            required: true
        },

        lvmwtZScoreDescription:{
            type: String,
            required: true
        },
        laDiameterZScoreLabel:{
            type: String,
            required: true
        },

        laDiameterZScoreDescription:{
            type: String,
            required: true
        },
        hcmScdScoreLabel:{
            type: String,
            required: true
        },

        hcmScdScoreDescription:{
            type: String,
            required: true
        },
        prognosticIndexLabel:{
            type: String,
            required: true
        },

        prognosticIndexDescription:{
            type: String,
            required: true
        },
        hcmScdRecommendationLabel: {
            type: String,
            required: true
        },
        hcmScdRecommendationDescription: {
            type: String,
            required: true
        },
        errorModalHeaderText: {
            type: String,
            required: true
        },
        errorModalFooterText: {
            type: String,
            required: true
        },
        
    },

    data() {
        return {
            userAgeValue: "",
            ageValidation: false,
            ageValidationError: "If the patient is less than 1 year old, please enter 0.",
            firstStep: false,
            secondStep: false,
            thirdStep: false,
            fourthStep: false,
            hideFirstScreen: true,
        };
    },

    methods: {
        handleValidation() {
            const age = Number(this.userAgeValue);

            if (this.userAgeValue.includes('.')) {
              
                this.ageValidationError = "Age can only be a whole number. If less than 1 year old, please enter 0."
                this.ageValidation = true;
                }else  if(age < 1 && age !== ""){
                this.ageValidationError = "Due to value entered, HCM Risk Kids cannot be computed.";
                this.ageValidation = true;
               }   else if (age < 0 || age > 80) {
                  this.ageValidationError = this.ageIfEightyErrorMessage;
                  this.ageValidation = true;
              } else  {
                this.ageValidationError = "If the patient is less than 1 year old, please enter 0."
                this.ageValidation = false;
              }
           
          

        },

        handleUpperInput() {
            this.userAgeValue = this.userAgeValue.replace(/[^0-9.]/g, "");
        },

        handleSecondScree() {
            this.secondStep = false;
            this.hideFirstScreen = true;
        },
        handleThirdScreen(){
            this.thirdStep = false;
            this.hideFirstScreen = true;
        },
        handleFourthScreen() {
            this.fourthStep = false;
            this.hideFirstScreen = true;
        },
        handleFirstScreen() {
            this.firstStep = false;
            this.hideFirstScreen = true;
        },

        redirectNxtScreen() {

            
            if (this.userAgeValue === "") {
                this.ageValidationError = this.ageErrorMessage;
                this.ageValidation = true;
            } else if (this.userAgeValue.includes('.')){
                this.ageValidationError = "Age can only be a whole number. If less than 1 year old, please enter 0."
                this.ageValidation = true;
            }
            else {
                const age = Number(this.userAgeValue);
                if (age >= 0 && age <= 15) {
                    this.hideFirstScreen = false;
                    this.firstStep = true;
                    this.ageValidation = false;
                    
                    
                } else if (age === 16) {
                    this.secondStep = true;
                    this.hideFirstScreen = false;
                    this.ageValidation = false;
                
                } 
                // else if (age === 17) {                  
                //     this.thirdStep = true;
                //     this.hideFirstScreen = false;
                //     this.ageValidation = false;
                   
                // } 
                else if (age >= 17 && age <= 80) {
                    this.fourthStep = true;
                    this.hideFirstScreen = false;
                    this.ageValidation = false;
                  
                }  else if (age < 0 || age > 80) {
                    this.ageValidation = true;
                    this.ageValidationError = this.ageIfEightyErrorMessage;
                }
                    else {
                    this.ageValidationError =
                    this.ageIfEightyErrorMessage;
                    this.ageValidation = true;
                }
            }
        },
    },
    mounted() {
        this.$root.$on("bv::modal::hidden", ($event) => {});
        
    },
};
</script>
<style>
.is-invalid {
    border-color: red !important;
}

.c-hero-card-snackable__content {
    left: 0px !important;
}

.cal-btn  {
    border:2px solid black;
}

.custom-invalid-feedback {
    display: block;
}
</style>



// WEBPACK FOOTER //
// demo/pages/components/primacy-calculator.vue